import masterData from "../masterData";

const getKeywordParamsList = value => {
  if (value.condition && value.condition.keyword) {
    const keywords = value.condition.keyword.split(/[\s　ｆ]/);
    return keywords.map(keyword => {
      const stationsMap = {};
      for (const station of masterData.station.list) {
        if (station.name.includes(keyword)) {
          stationsMap[station.stationId] = true;
        }
      }
      for (const line of masterData.line.list) {
        if (line.name.includes(keyword)) {
//          console.log("line match", line);
          for (const stationId of line.stations) {
            stationsMap[stationId] = true;
          }
        }
      }
//      console.log(keyword, stationsMap);
      return {
        keyword,
        stationsMap,
      };
    });
  } else {
    return null;
  }
};

/* eslint-disable complexity */
export const searchAsset = (value, { pref, city }) => {
  console.log('condition', value.condition)
  const keywordParamsList = getKeywordParamsList(value);
//  console.log(keywordParamsList);
  const condition = Object.assign({}, value.condition);
  condition.city = condition.city && new Set(condition.city)
  condition.line = condition.line && new Set(condition.line)
  condition.station = condition.station && new Set(condition.station.map((stationId) => {
    const station = masterData.station.byId[stationId];
    return station && station.stationId;
  }).filter(item => item))
  if (condition.campaign == 1) {
    condition.campaignAll = true;
    condition.campaign = null;
  } else if (condition.campaign && condition.campaign.length) {
    condition.campaign = new Set(condition.campaign)
  } else {
    condition.campaign = null;
  }
  function distance(lat1, lng1, lat2, lng2) {
    lat1 *= Math.PI / 180;
    lng1 *= Math.PI / 180;
    lat2 *= Math.PI / 180;
    lng2 *= Math.PI / 180;
    return 6371 * Math.acos(Math.cos(lat1) * Math.cos(lat2) * Math.cos(lng2 - lng1) + Math.sin(lat1) * Math.sin(lat2));
  }
  const SUBURBS_DISTANCE = 5;

  // タイプ選択によって有効な項目を切り替える
  let setsubiAvailableFlg = true;
  let floorAvailableFlg = true;
  if (condition.assetType && condition.assetType.length) {
    let test = '';
    if (condition.assetType.indexOf("okunai") == -1) {
      if (condition.assetType.indexOf("okugai") != -1) {
        //「屋外だけ」「屋外＆バイク」の時
        setsubiAvailableFlg = false;
      }
      else if (condition.assetType.indexOf("bikeonly") != -1) {
        //「バイクだけ」の時
        setsubiAvailableFlg = false;
        floorAvailableFlg = false;
      }
    }
  }

  let filteredData = JSON.parse(JSON.stringify(masterData.asset.list));

  filteredData = filteredData.filter(asset => {
    if (condition) {
      // 設備
      if (condition.facility && condition.facility.length) {
        let facilityCount = condition.facility.length;
        let matchCount = 0;
        if (setsubiAvailableFlg) {
          if (condition.facility.indexOf("parking") != -1 && asset.tags.indexOf("駐車場有") != -1) {
            matchCount++;
          }
          if (condition.facility.indexOf("elevator") != -1 && asset.tags.indexOf("エレベーター有") != -1) {
            matchCount++;
          }
          if (condition.facility.indexOf("aircon") != -1 && asset.tags.indexOf("空調有") != -1) {
            matchCount++;
          }
        }
        else {
          facilityCount -= condition.facility.indexOf("parking") != -1 ? 1 : 0;
          facilityCount -= condition.facility.indexOf("elevator") != -1 ? 1 : 0;
          facilityCount -= condition.facility.indexOf("aircon") != -1 ? 1 : 0;
        }
        if (condition.facility.indexOf("access") != -1 && asset.tags.indexOf("駅近物件") != -1) {
          matchCount++;
        }
        if(matchCount == 0 || matchCount != facilityCount){
          return false;
        }
      }
      if (condition.city) {
        if (!condition.city.has(asset.city) && !condition.city.has(asset.baseCity)) {
          return false;
        }
      }
      if (condition.pref) {
        if (asset.pref !== condition.pref) {
          return false;
        }
      }
      if (condition.line) {
        if (!asset.stations || !asset.stations.some(stationInfo => {
          const station = masterData.station.byId[stationInfo.station];
          return station && station.lines.some(line => {
            return condition.line.has(line);
          });
        })) {
          return false;
        }
      }
      if (condition.station) {
        if (!asset.stations || !asset.stations.some(stationInfo => condition.station.has(stationInfo.station))) {
          return false;
        }
      }
      if (condition.assetType && condition.assetType.length) {
        let flg = false;
        if(asset.bike == 1 && condition.assetType.indexOf("bikeonly") != -1){
          flg = true;
        //}else if(asset.premium == 1 && condition.assetType.indexOf("premium") != -1){
        //  flg = true;
        }else if(asset.assetType == "okugai" && condition.assetType.indexOf("okugai") != -1){
          flg = true;
        //}else if(asset.assetType == "okunai" && asset.premium != "1" && condition.assetType.indexOf("okunai") != -1){
        } else if (asset.assetType == "okunai" && condition.assetType.indexOf("okunai") != -1) {
          flg = true;
        }
        if(!flg){
          return false;
        }
      }
      if (condition.price) {
        const { minValue, maxValue } = masterData.price.byValue[
          condition.price
        ];
        if (
          !(
            (!minValue || asset.max_price >= minValue) &&
            (!maxValue || asset.min_price < maxValue)
          )
        ) {
          return false;
        }
      }
      if (condition.extent) {
        const { minValue, maxValue } = masterData.extent.byValue[
          condition.extent
        ];
        if (
          !(
            (!minValue || asset.max_extent >= minValue) &&
            (!maxValue || asset.min_extent < maxValue)
          )
        ) {
          return false;
        }
      }
      if (!condition.manshitsu) {
        if (asset.manshitsu ==1) {
          //return false;
        }
      }
      if (condition.campaign) {
        if (!asset.campaigns || asset.campaigns.length == 0) {
          return false;
        }
      }
      if (condition.near) {
        if (!asset.min_station_distance || asset.min_station_distance > 10) {
          return false;
        }
      }
      // キーワード検索
      if (keywordParamsList) {
        if (
          !keywordParamsList.every(keywordParams => {
            // 住所検索
            if (condition.keywordTarget == 1) {
              if (asset.address && asset.address.includes(keywordParams.keyword)) {
                return true;
              }
            }
            // 駅名検索
            else if (condition.keywordTarget == 2) {
              if (
                asset.stations && asset.stations.some(stationInfo => {
                  return keywordParams.stationsMap[stationInfo.station];
                })
              ) {
                return true;
              } else {
                return false;
              }
            }
            // 物件名検索
            else if (condition.keywordTarget == 3) {
              if (asset.name && asset.name.includes(keywordParams.keyword)) {
                return true;
              }
            }
            // すべて検索
            else {
              if (asset.address && asset.address.includes(keywordParams.keyword)) {
                return true;
              } else if (asset.name && asset.name.includes(keywordParams.keyword)) {
                return true;
              } else if (asset.zip_cd && asset.zip_cd.includes(keywordParams.keyword)) {
                return true;
              } else if (asset.geo && keywordParams.keyword.startsWith('geo')) {
                const words = keywordParams.keyword.split('_');
                if (words.length == 3 && distance(asset.geo.lat, asset.geo.lng, words[1], words[2]) < SUBURBS_DISTANCE){
                  return true;
                }
              } else if (asset.tags && asset.tags.some(tag => {
                return tag.includes(keywordParams.keyword)
              })) {
                return true;
              } else if (
                asset.stations && asset.stations.some(stationInfo => {
                  return keywordParams.stationsMap[stationInfo.station];
                })
              ) {
                return true;
              } else {
                return false;
              }
            }
          })
        ) {
          return false;
        }
      }
    }
    if (pref) {
      if (asset.pref !== pref.prefId) {
        return false;
      }
    }
    if (city) {
      if (asset.city !== city.slug) {
        return false;
      }
    }

    // 空き部屋ステータス　9：空室なし　0：空室あり
    const length = Object.keys(asset.vacantFloorJou).length;
    asset.vacantStatus = length == 0 ? 9 : 0;

    return true;
  });

  // 部屋情報のマージと空き状態チェック
  filteredData = filteredData.filter(asset => {

    let vacantCount = Object.keys(asset.vacantFloorJou).length;
    let akiyoteiCount = Object.keys(asset.akiyoteiFloorJou).length;

    /*
    // 空室のある物件から検索以外なら
    if (condition.targetState && (condition.targetState == 1 || condition.targetState == 2)) {
      // 空き予定部屋が存在したらvacantFloorJouにマージする
      if (asset.akiyoteiCount > 0) {
        for (let aKai in asset.akiyoteiFloorJou) {
          for (let aKey in asset.akiyoteiFloorJou[aKai]) {
            let curKaiKeys = Object.keys(asset.vacantFloorJou);
            let curKaiIdx  = curKaiKeys.indexOf(aKai);
            if (curKaiIdx >= 0) {
              let curJouKeys = Object.keys(asset.vacantFloorJou[curKaiKeys[curKaiIdx]]);
              let findFlg = false;
              for (let curJouKey in curJouKeys) {
                if (asset.vacantFloorJou[curKaiKeys[curKaiIdx]][curJouKeys[curJouKey]] == aKey) {
                  findFlg = true;
                }
              }
              // 階はあるが帖が存在しなかった場合
              if (findFlg === false) {
                asset.vacantFloorJou[aKai][aKey] = parseFloat(aKey);
              }
            }
            // 階すら存在しなかった場合
            else {
              asset.vacantFloorJou[aKai] = {};
              asset.vacantFloorJou[aKai][aKey] = parseFloat(aKey);
            }
          }
        }
      }
    }
    */

    // この時点で空き部屋も空き予定部屋も無ければ
    if (vacantCount == 0 && akiyoteiCount == 0) {
      // 空室なし空き予定なし
      asset.vacantStatus = 9;
      return true;
    }

    // 部屋に対する検索条件がない場合
    if (!condition.priceFrom && !condition.priceTo && !condition.floor && !condition.extentFrom && !condition.extentTo) {
      if (vacantCount > 0) {
        // 条件に合致する空室がある
        asset.vacantStatus = 0;
        return true;
      }
      if (akiyoteiCount > 0) {
        // 条件に合致する空室はないが、空き予定部屋がある
        asset.vacantStatus = 1;
        return true;
      }
    }

    // ○△×の判定（空室）
    let matchFlg;
    if (asset.vacantDeviceInfo.vacant) {
      for (let val of asset.vacantDeviceInfo.vacant) {
        matchFlg = true;
        // 金額（月額使用料）from
        if (condition.priceFrom) {
          if (val['rent'] < condition.priceFrom) {
            matchFlg = false;
          }
        }
        // 金額（月額使用料）to
        if (condition.priceTo) {
          if (val['rent'] > condition.priceTo) {
            matchFlg = false;
          }
        }
        // 階数
        if (condition.floor) {
          if (condition.floor == '1') {
            if (val['floor'] != 1) {
              matchFlg = false;
            }
          }
          else if (condition.floor == '2') {
            if (val['floor'] == 1) {
              matchFlg = false;
            }
          }
        }
        // 広さfrom
        if (condition.extentFrom) {
          if (val['jou'] < condition.extentFrom) {
            matchFlg = false;
          }
        }
        // 広さto
        if (condition.extentTo) {
          if (val['jou'] > condition.extentTo) {
            matchFlg = false;
          }
        }
        // この時点でtrueなら
        if (matchFlg === true) {
          // 条件に合致する空室がある
          asset.vacantStatus = 0;
          return true;
        }
      }
    }

    // ○△×の判定（空き予定）
    if (asset.vacantDeviceInfo.akiyotei) {
      for (let val of asset.vacantDeviceInfo.akiyotei) {
        matchFlg = true;
        // 金額（月額使用料）from
        if (condition.priceFrom) {
          if (val['rent'] < condition.priceFrom) {
            matchFlg = false;
          }
        }
        // 金額（月額使用料）to
        if (condition.priceTo) {
          if (val['rent'] > condition.priceTo) {
            matchFlg = false;
          }
        }
        // 階数from
        if (condition.floorFrom) {
          if (val['floor'] < condition.floorFrom) {
            matchFlg = false;
          }
        }
        // 階数to
        if (condition.floorTo) {
          if (val['floor'] > condition.floorTo) {
            matchFlg = false;
          }
        }
        // 広さfrom
        if (condition.extentFrom) {
          if (val['jou'] < condition.extentFrom) {
            matchFlg = false;
          }
        }
        // 広さto
        if (condition.extentTo) {
          if (val['jou'] > condition.extentTo) {
            matchFlg = false;
          }
        }
        // この時点でtrueなら
        if (matchFlg === true) {
          // 条件に合致する空き予定部屋がある
          asset.vacantStatus = 1;
          return true;
        }
      }
    }

    // 条件に合致する部屋はないが、他に空室か空き予定の部屋はある
    asset.vacantStatus = 2;
    return true;
  });

  // 空室条件に関するフィルタリング
  filteredData = filteredData.filter(asset => {

    // 空室のある物件から検索の場合
    if (!condition.targetState || condition.targetState == 0) {
      if (asset.vacantStatus != 0) {
        return false;
      }
    }

    // 空き予定のある物件から検索の場合
    if (condition.targetState && condition.targetState == 1) {
      if (asset.vacantStatus != 0 && asset.vacantStatus != 1) {
        return false;
      }
    }

    return true;

  });

  return filteredData;
};

searchAsset.injects = ["station", "line", "asset"];



// WEBPACK FOOTER //
// ./lib/masterUtil/searchAsset.js